import { createGlobalStyle } from "styled-components/macro"
import colors from "./colors"

export default createGlobalStyle`
  html,
  body {        
    box-sizing: border-box;    
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  html, body {
    height: 100%;
    font-family: 'Montserrat', sans-serif;
  }

  body {
    background-color: #ffffff;
    color: ${colors.app.text.main};
  }
`
